import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2'
import Layout from '../../Components/Layout'
import Breadcrumb from './Component/Breadcrumb'
import Sidebar from './Component/Siderbar'
import config from '../../config';
import { MdOutlineCancel } from "react-icons/md";
import { TiTick } from "react-icons/ti";
import { FaRegClock } from "react-icons/fa";
import { IoListCircleOutline } from "react-icons/io5";
import { FaEuroSign, FaDollarSign, FaLiraSign } from "react-icons/fa";
import { getPrice, formatPrice } from '../../services/priceUtils';
import { useCurrency } from '../../context/CurrencyContext';

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user_data'));
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [orders, setOrders] = useState([]);
    const [hotels, setHotels] = useState([]);
    const [notifications, setNotifications] = useState([]);
    const [users, setUsers] = useState([]);
    const [wallet, setWallet] = useState([]);
    const [stats, setStats] = useState([]);
    const [originalAmount, setOriginalAmount] = useState(0);
    const [formattedTotalAmount, setFormattedTotalAmount] = useState('0.00');
    
    // CurrencyContext'ten para birimi bilgisini al
    const { selectedCurrency, formatPrice: formatCurrencyPrice } = useCurrency();
    

    useEffect(() => {
        const updateTotalAmount = async () => {
            if (originalAmount > 0) {
                try {
                    const formattedAmount = await getPrice(originalAmount, userData.token, selectedCurrency);
                    setFormattedTotalAmount(formattedAmount);
                } catch (error) {
                    console.error("Error updating total amount:", error);
                }
            }
        };

        updateTotalAmount();
    }, [selectedCurrency, originalAmount, userData?.token]);

    useEffect(() => {
        setLoading(true);

        const fetchData = async () => {
            try {
              const response = await fetch(`${config.API_BASE_URL_V1}data`, {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${userData.token}`,
                  'Content-Type': 'application/json',
                },
              });
      
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
      
              const data = await response.json();
              setData(data.data);
              setWallet(data.data.walletHistory);
            } catch (error) {
              console.error('Error fetching data:', error);
            }
        };

        const fetchStats = async () => {
            try {
                const response = await axios.get(
                `${config.API_BASE_URL_V1}order/stats`,
                {
                    headers: {
                        Authorization: `Bearer ${userData.token}`,
                        "Content-Type": "application/json",
                    },
                }
                );
                if (response.data.status === "success") {
                  setStats(response.data.data);
                  
                  if (response.data.data.total_amount) {
                    setOriginalAmount(response.data.data.total_amount);
                  }
                }
            } catch (error) {
                console.error("Error fetching stats:", error);
            }
        };

        const fetchOrders = async () => {
            try {
                const params = {
                  page: 1,
                  perPage: 5,
                };
              
                const response = await axios.get(`${config.API_BASE_URL_V1}order`, {
                  params,
                  headers: {
                    Authorization: `Bearer ${userData.token}`,
                    "Content-Type": "application/json",
                  },
                });
              
                if (response.data.status === "success") {
                  setOrders(response.data.data.data);
                }
            } catch (error) {
                console.error("Error fetching orders:", error);
            }
        };

        const fetchNotification = async () => {
            try {
                const params = {
                  page: 1,
                  perPage: 5,
                };
              
                const response = await axios.get(`${config.API_BASE_URL_V1}notification/list`, {
                  params,
                  headers: {
                    Authorization: `Bearer ${userData.token}`,
                    "Content-Type": "application/json",
                  },
                });

                console.log('notifactiopn: ',response);
                
                if (response.data && response.data.data) {
                  setNotifications(response.data.data);
                }
              
            } catch (error) {
                console.error("Error fetching notifications:", error);
            }
        };
      
        fetchNotification();
        fetchOrders();
        fetchData();
        fetchStats();
        setLoading(false);
      }, []);

      console.log('orders: ',orders, 'stats: ',stats)

      // Para birimi ikonunu seç
      const getCurrencyIcon = () => {
        switch(selectedCurrency) {
          case 'USD':
            return <FaDollarSign className='fs-36'/>;
          case 'TRY':
            return <FaLiraSign className='fs-36'/>;
          case 'EUR':
          default:
            return <FaEuroSign className='fs-36'/>;
        }
      };

      const renderLoader = () => {
        if (loading) {
          return (
            <div id="loader-wrapper">
                <div id="loader">
                    <span className="loader-line"></span>
                </div>
            </div>
          );
        }
        return null;
      };

return (
<Layout>
    {renderLoader()}
    <Breadcrumb title="Dashboard" />
    <div className="content content-two">
        <div className="container">
            <Sidebar>
                <div className="row mb-4">
                    <div className="col-xl-4">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <span style={{ backgroundColor:'blue' }} class="avatar avatar-xl rounded-circle me-3">
                                        <IoListCircleOutline className='fs-36'/>
                                    </span>
                                    <div>
                                        <h3> { stats?.total_orders ?? '0' } </h3>
                                        <p>Total Booking</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4">
                        <div className="card ">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <span style={{ backgroundColor:'orange' }} class="avatar avatar-xl rounded-circle me-3">
                                        <FaRegClock className='fs-36'/>
                                    </span>
                                    <div>
                                        <h3> { stats?.total_pending_orders ?? '0' } </h3>
                                        <p>Pending Booking</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4">
                        <div className="card ">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <span style={{ backgroundColor:'green' }} class="avatar avatar-xl rounded-circle me-3">
                                        <TiTick className='fs-36'/>
                                    </span>
                                    <div>
                                        <h3> { stats?.total_paid_orders ?? '0' } </h3>
                                        <p>Paid Booking</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4">
                        <div className="card ">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <span style={{ backgroundColor:'red' }} class="avatar avatar-xl rounded-circle me-3">
                                        <MdOutlineCancel className='fs-36'/>
                                    </span>
                                    <div>
                                        <h3> { stats?.total_failed_orders ?? '0' } </h3>
                                        <p>Failed Booking</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="card ">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <span className="avatar avatar-xl rounded-circle bg-secondary me-3">
                                        {getCurrencyIcon()}
                                    </span>
                                    <div>
                                        <h3> {formatPrice(formattedTotalAmount, selectedCurrency)} </h3>
                                        <p>Total Amount</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-7">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h6>Bookings</h6>
                                </div>
                                {Array.isArray(orders) && orders.length > 0 ? (
                                    orders.slice(0, 5).map((booking, index) => (
                                        <div className="card mb-2" key={index}>
                                            <div className="card-body">
                                                <div className="d-flex align-items-center row-gap-2 flex-wrap">
                                                    <div className="flex-fill">
                                                        <span className="badge badge-soft-info badge-xs rounded-pill mb-1">
                                                            <i className="isax isax-buildings me-1"></i> {booking.order_number}
                                                        </span>
                                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                                            <h6 className="fs-16 text-truncate">
                                                                <a href="hotel-details.html">
                                                                    {booking.holder_info.firstName} {booking.holder_info.lastName}
                                                                    <span className="text-gray-5 fw-normal fs-14">
                                                                        {" "} ({booking.order_number})
                                                                    </span>
                                                                </a>
                                                            </h6>
                                                            <span className={`badge ${booking.payment_status === "failed" ? "badge-danger" : "badge-purple"} badge-sm rounded-pill`}>
                                                                <i className="ti ti-point-filled me-1"></i>
                                                                {booking.payment_status === "failed" ? "Payment Failed" : "Paid"}
                                                            </span>
                                                        </div>
                                                        <div className="d-flex align-items-center flex-wrap">
                                                            <p className="fs-14 d-flex align-items-center border-end mb-0 me-2 pe-2">
                                                                <i className="isax isax-calendar-25 me-2"></i>
                                                                Check-in: {new Date(booking.check_in_date).toLocaleDateString()}
                                                            </p>
                                                            <p className="fs-14 d-flex align-items-center border-end mb-0 me-2 pe-2">
                                                                <i className="isax isax-calendar-25 me-2"></i>
                                                                Check-out: {new Date(booking.check_out_date).toLocaleDateString()}
                                                            </p>
                                                            <p className="fs-14 d-flex align-items-center">
                                                                <i className="isax isax-cash me-2"></i>
                                                                Total: ${booking.with_markup_price}
                                                            </p>
                                                        </div>
                                                        <div className="d-flex align-items-center flex-wrap mt-1">
                                                            <p className="fs-14 d-flex align-items-center border-end mb-0 me-2 pe-2">
                                                                <i className="isax isax-call me-2"></i>
                                                                {booking.holder_info.phone}
                                                            </p>
                                                            <p className="fs-14 d-flex align-items-center">
                                                                <i className="isax isax-sms me-2"></i>
                                                                {booking.holder_info.email}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p>No bookings available</p>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-5">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h6>Notifications</h6>
                                </div>
                                {Array.isArray(notifications) && notifications.length > 0 ? (
                                    <>
                                        {notifications.map((item, index) => (
                                        <div key={index} className="d-flex align-items-center mb-3">
                                            <span className="avatar avatar-lg bg-primary rounded-circle me-2 flex-shrink-0">
                                            <i className="isax isax-info-circle5"></i>
                                            </span>
                                            <div className="flex-fill overflow-hidden">
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                <h6 className="fs-16 text-truncate"> {item.title} </h6>
                                                <p className="fs-14 text-primary text-nowrap">
                                                {(() => {
                                                    const date = new Date(item.data?.order_date);
                                                    const options = { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false };
                                                    return date.toLocaleDateString('en-US', options).replace(',', '');
                                                })()}
                                                </p>
                                            </div>
                                            <p className="fs-14 two-line-ellipsis"> {item.message} </p>
                                            </div>
                                        </div>
                                        ))}
                                    </>
                                ) : (
                                    <>No data in notifications.</>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h6>Credit History</h6>
                                </div>
                                {Array.isArray(wallet) && wallet.length > 0 ? (
                                    wallet.map((transaction, index) => (
                                        <div className="card mb-2" key={index}>
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <h6 className="fs-16 mb-1">{transaction.description}</h6>
                                                        <p className="fs-14 text-muted mb-0">
                                                            <i className="isax isax-calendar me-1"></i>
                                                            Date: {transaction.created_at}
                                                        </p>
                                                        <p className="fs-14 text-muted mb-0">
                                                            <i className="isax isax-user me-1"></i>
                                                            User: {transaction.user}
                                                        </p>
                                                    </div>
                                                    <div className="text-end">
                                                        <span className={`badge ${transaction.type === "increase" ? "badge-success" : "badge-danger"} fs-14`}>
                                                            {transaction.type === "increase" ? "+" : "-"} {transaction.amount} EUR
                                                        </span>
                                                        <p className="fs-14 text-muted mb-0">
                                                            <i className="isax isax-wallet me-1"></i>
                                                            Balance: {transaction.balanceAfter} EUR
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <>No data in wallet transactions.</>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Sidebar>
        </div>
    </div>
</Layout>
)
}
